import { render, staticRenderFns } from "./CategoryCarousel.vue?vue&type=template&id=7945759f&"
import script from "./CategoryCarousel.vue?vue&type=script&lang=ts&"
export * from "./CategoryCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports